import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import SelectField from "../common/textfield/SelectField";
import * as Yup from "yup";
import { DateSelectorWithoutFormik } from "../common/textfield/DateSelector";
import { CircularProgress, Skeleton } from "@mui/material";
import moment from "moment";
import TextInput from "../common/textfield/TextInput";
import TextArea from "../common/textfield/TextArea";
import { decryptData } from "../EncryptDecrypt";
import { Button } from "../common/Button";
import { failed, success } from "../common/Toastify";
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { Form } from "react-bootstrap";
import { bookAppointment, checkShedule, getSlots, listOrgSlots, listServiceForOrg } from "../apps/api/AppointmentRequests";
import { createQuestionnaire, updateQuestionnaire } from "../api/Questionnaires";
import { generatePass } from "../../components/apps/AppointmentRequests/Constants";
import { getSignature } from '../../components/Zoom/functions';
import './style.css';
import { handleFileUpload } from "../../utils/ImageToBase64";
import { act } from "react";



const BookAppointmentModal = ({ bookAppointmentModalShow, handleBookAppointmentClose, type = "patient", formikQuestionnaire, providerPreference, practitionerId = "", actorId ="" }) => {
    const user = useSelector((state) => state?.auth?.user);
    const patientLocation = (formikQuestionnaire?.location || '');

    const storedProfile = sessionStorage.getItem("relatedPersonProfile");
    const storedId = storedProfile ? JSON.parse(storedProfile).id : null;
    const loggedInUserInfo = JSON.parse(localStorage.getItem("loggedInUserInfo"));
    const authorName = loggedInUserInfo?.name?.[0]?.text;
    const patientId = useSelector((state) => storedId || state?.auth?.user?.["custom:patient_id"]);

    //const patientId = user?.user['custom:unique_id'];
    const orgId = useSelector((state) => state?.auth?.user?.orgId);
    const [availableSlots, setAvailableSlots] = useState([]);
    const [serviceCategory, setServiceCategory] = useState([]);
    const [slotsLoading, setSlotsLoading] = useState(false);
    const [practitionerList, setPractitionerList] = useState([]);
    const [showDateField, setShowDateField] = useState(false);
    const [todayDate, setTodayDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [selectedSlot, setSelectedSlot] = useState("");
    const [loading, setLoading] = useState(false);
    const [orgServiceCategory, setOrgServiceCategory] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [categoriesByDay, setCategoriesByDay] = useState({});
    const [availableDays, setAvailableDays] = useState([]);
    const [slotPractitionerId, setSlotPractitionerId] = useState('');
    const [selectedServiceCategory, setSelectedServiceCategory] = useState(null);

    const isTagPresent = (tagValue) => formikQuestionnaire?.formikQuestionnaire?.some(item => item.tag === tagValue);


    const formik = useFormik({
        initialValues: {
            date: "",
            serviceCategory: "",
            availableSlot: "",
            preferredChannel: "",
            returnTelephoneNumber: "",
            returnTelephoneNumberExt: "",
            practitionerPreference: providerPreference,
            practitioner: practitionerId,
            fileAttachments: []
        },
        validationSchema: Yup.object({
            date: Yup.string().required("Required Date field."),
            serviceCategory: Yup.string().required("Required Appointment type field."),
            availableSlot: Yup.object().required("Required slots field."),
        }),
        onSubmit: async (values) => {
        setLoading(true);

        try {
            // ---- Build document list ----
            let documentToBeSent = null;
            if (values.fileAttachments?.length > 0) {
            documentToBeSent = await Promise.all(
                values.fileAttachments.map(async (file) => {
                const base64 = (await handleFileUpload(file)).split(',')[1];
                return {
                    data: base64,
                    extension: file.type.split('/')[1],
                    name: file.name,
                };
                })
            );
            }

            // ---- Prepare appointment payload ----
            const { start: utcStart, end: utcEnd, scheduleId } = values?.availableSlot || {};
            const requestedPeriod = [{ start: utcStart, end: utcEnd }];

            const payload = {
            actor: {
                reference: `Patient/${patientId}`,
                display: authorName,
            },
            practitionerId: slotPractitionerId || values?.practitioner || practitionerId,
            patientId,
            actorId: patientId,
            requestedPeriod,
            schedulerId: scheduleId,
            patientLocation,
            document: documentToBeSent,
            serviceCategory: [
                {
                coding: [
                    {
                    system: 'http://florizel.com/AppointmentServiceCategory',
                    code: selectedServiceCategory?.id,
                    display: selectedServiceCategory?.name,
                    },
                ],
                text: `Appointment for ${selectedServiceCategory?.name}`,
                },
            ],
            };

            // ---- Questionnaire handling ----
            const questionResponse = formikQuestionnaire;
            let questionnaireResponseObj = {};
            let questionnaireResponseResult = null;

            if (questionResponse?.formikQuestionnaire?.length) {
            for (const element of questionResponse.formikQuestionnaire) {
                let answer = '';

                if (element.questionType === 'dropDown') {
                answer =
                    element.answer.find((val) => val.answer === val.id)?.text || '';
                } else if (element.questionType === 'radio') {
                answer =
                    element.answer.find((val) => val.answer)?.option || '';
                } else {
                answer = element.answer?.[0]?.answer || '';
                }

                switch (element.tag) {
                case 'TELEPHONE':
                    questionnaireResponseObj.callerNumber = answer.split(' ext ')[0];
                    if (answer.includes(' ext ')) {
                    questionnaireResponseObj.callerNumberExt = answer.split(' ext ')[1];
                    }
                    break;
                case 'CHANNEL':
                    questionnaireResponseObj.preferredChannel = answer;
                    break;
                case 'LOCATION':
                    questionnaireResponseObj.location = answer;
                    break;
                case 'REASON':
                    payload.description = answer;
                    questionnaireResponseObj[element.question] = answer;
                    break;
                default:
                    if (element.tag) {
                    questionnaireResponseObj[element.tag.toLowerCase()] = answer;
                    }
                    questionnaireResponseObj[element.question] = answer;
                }
            }

            const questionnairePayload = {
                patientID: patientId,
                questionResponse: questionResponse.formikQuestionnaire,
                questionnaire: questionResponse.questionnaireId,
                authorName,
                authorType: 'Patient',
                authorId: patientId,
            };

            questionnaireResponseResult = await createQuestionnaire(questionnairePayload);

            questionnaireResponseObj.questionnaireResponseId = {
                reference: `QuestionnaireResponse/${questionnaireResponseResult?.data?.id}`,
            };
            }

            if (Object.keys(questionnaireResponseObj).length) {
            payload.intakeQuestions = questionnaireResponseObj;
            }

            // ---- Book appointment ----
            const appointmentResponse = await bookAppointment(payload);

            if (appointmentResponse?.status) {
            if (questionnaireResponseResult) {
                const updatedPayload = {
                encounterId: appointmentResponse?.result?.encounterId,
                patientID: patientId,
                authorId: patientId,
                authorType: 'Patient',
                authorName,
                };
                await updateQuestionnaire(updatedPayload, questionnaireResponseResult?.data?.id);
            }
            success('Appointment Request Sent');
            } else {
            failed(appointmentResponse?.message || 'Booking failed');
            }
        } catch (err) {
            failed(
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            err.message
            );
        } finally {
            setLoading(false);
            handleBookAppointmentClose();
        }
        }

    });

    const handleDateChange = (val) => {
        formik.setFieldValue("date", val.format("YYYY-MM-DD"));
        fetchSlots(formik?.values?.serviceCategory, val.format("YYYY-MM-DD"));
        console.log("stored Profile:", JSON.stringify(storedProfile, undefined, 4));
        console.log("Logged in user info:", JSON.stringify(loggedInUserInfo, undefined, 4));
    };

    /**
 * buildDayMap
 * builds a hash map all days (local timezone) in the date range
 * in YYYY-MM-DD format so something like this:
 * {
 *      "2025-01-01": [],
 *      "2025-01-02": [],
 *      ...
 * }
 * @param {date, local time} start 
 * @param {date, local time} end 
 * @returns hash map of all days for the date range with empty arrays for each day
 */
    const buildDayMap = (start, end) => {
        let dayMap = {};
        let current = new Date(start); // clone so caller’s date isn’t mutated
        while(current <= end) { 
            let daystring = `${current.toISOString().split("T")[0]}`;
            dayMap[daystring] = [];
            current.setDate(current.getDate() + 1); // increase to next day
        }
        return dayMap;
    };

    /**
     * checkCategoryForDay
     * adds valid categories for a day, trying to take into account timezone offsets.
     * @param {json object} dateMap 
     * @param {json object} planningHorizon 
     * @param {json object} category 
     */
    const checkCategoryForDay = (dateMap, planningHorizon, category) => {
    // clone the dateMap so we don’t mutate caller
    let newDateMap = structuredClone(dateMap);

    for (const date in newDateMap) {
        // local day start and end
        let dayStartUTC = new Date(date + "T00:00:00Z");
        let dayEndUTC = new Date(date + "T00:00:00Z");
        dayEndUTC.setUTCDate(dayEndUTC.getUTCDate() + 1);

        let dayStartMS = dayStartUTC.getTime();
        let dayEndMS = dayEndUTC.getTime();

        let catDate = new Date(category.date);
        let pHStartDate = new Date(planningHorizon.start);
        let pHEndDate = new Date(planningHorizon.end);

        let validCatStart = new Date(catDate);
        validCatStart.setUTCHours(pHStartDate.getUTCHours(), pHStartDate.getMinutes());

        let validCatEnd = new Date(catDate);
        validCatEnd.setUTCHours(pHEndDate.getUTCHours(), pHEndDate.getMinutes());

        // handle overnight horizons (e.g. 10pm–6am)
        if (pHStartDate.getUTCHours() > pHEndDate.getUTCHours()) {
            validCatEnd.setUTCDate(validCatEnd.getUTCDate() + 1);
        }

        let validCatStartMS = validCatStart.getTime();
        let validCatEndMS = validCatEnd.getTime();

        // --- simplified overlap check ---
        let add = (dayStartMS < validCatEndMS) && (dayEndMS > validCatStartMS);
        // --------------------------------

        if (add) {
            if (!newDateMap[date].some(id => id === category.id)) {
                newDateMap[date] = [...newDateMap[date], category.id]; // clone array instead of push
            }
        }
    }
    return newDateMap;
};


    /**
     * addCategory
     * adds a category that is available.
     * @param {json object} hashMap 
     * @param {json object} category 
     * @param {array} currentCategories 
     * @returns array
     */
    const addCategory = (hashMap, category, currentCategories) => {
        let newCategories = [...currentCategories]; // clone so caller isn’t mutated
        for(const val in hashMap) {
            let values = hashMap[val];
            if(values.includes(category.id)) {
                if(!newCategories.some(item => item.id === category.id)) {
                    newCategories = [...newCategories, { name: category.name, id: category.id, value: category.id }];
                }
            }
        }
        return newCategories;
    };

    /**
     * stripEmptyValues
     * loops through properties in hashMap, and if the value is an empty array or a null
     * delete the property.
     * @param {*} hashMap 
     * returns map with only properties that have values;
     */
    const stripEmptyValues = hashMap => {
        let cleanedMap = {};
        for(const val in hashMap) {
            let hasValue = true;
            if(!hashMap[val]) 
                hasValue = false;
            else if(Array.isArray(hashMap[val]) && hashMap[val].length === 0) 
                hasValue = false;
            else if(typeof hashMap[val] === "object" 
                && Object.getOwnPropertyNames(hashMap[val]).length === 0) 
                hasValue = false;
            
            if(hasValue) 
                cleanedMap[val] = hashMap[val];
        }
        return cleanedMap;
    };


    useEffect(() => {
        const fetchSchedules = async () => {
            let startTime = (!formik?.values?.date) ? moment().utc() : moment(formik?.values?.date).utc(); // if a date is provided, use it, otherwise, use now.
            let startLocal = (!formik?.values?.date) ? moment() : moment(formik?.values?.date);
            let start = startLocal.format("YYYY-MM-DD");
            
            // make hashmap for range of days being searched.
            let rangeStart = new Date(start);
            let rangeEnd = new Date(startLocal.add(1, 'M').format('YYYY-MM-DD'));
            let datesInRange = buildDayMap(rangeStart, rangeEnd);
            
            try {
                let params = {};
                if(formik.values?.practitioner) {
                    params = {
                        date: startTime.format('YYYY-MM-DDTHH:mm:ss')+"Z",
                        actorId: formik.values?.practitioner,
                        endDate: startTime.add(1,'M').format('YYYY-MM-DDTHH:mm:ss')+"Z",
                        isGetAll: false
                    }
                }
                else {
                    params = {
                        date: startTime.format('YYYY-MM-DDTHH:mm:ss')+"Z",
                        actorId: actorId,
                        orgId: orgId,
                        endDate: startTime.add(1,'M').format('YYYY-MM-DDTHH:mm:ss')+"Z",
                    }    
                }
                
                const schedules = await checkShedule(params);
                if (schedules && schedules.data.length <= 0) {
                    failed('No active practitioners available');
                }
                else if(schedules.data) {
                        let categories = [];
                        if (!Array.isArray(schedules.data)) 
                            schedules.data = [schedules.data];
                        schedules.data.forEach(schedule => {
                            let planningHorizon = schedule.planningHorizon;

                            schedule.serviceCategory.forEach(category => {
                                if (category.id) {
                                    datesInRange = checkCategoryForDay(datesInRange, planningHorizon, category); 
                                    categories = addCategory(datesInRange, category, categories);
                                }
                            });                   
                        })

                        console.log("DATES IN RANGE", JSON.stringify(datesInRange, undefined, 4))
                        datesInRange = stripEmptyValues(datesInRange); // remove empty days
                        setCategoriesByDay(datesInRange);
                        setServiceCategory(categories);
                        console.log("CATEGORIES", JSON.stringify(categories, undefined, 4))
                        //console.log("DATES IN RANGE", JSON.stringify(datesInRange, undefined, 4))
                }                        
            }
                
            
            catch(error) {
                setServiceCategory([]);
                setCategoriesByDay({});
                setAvailableSlots([]);
                failed('Error retrieving appointment types');
            }
        };

        fetchSchedules();
    }, [practitionerId]);



    const highLightDates = (catId) => {
        setAvailableDays([]);
        let today = moment();
        let toHighlight = [];
        for (const dates in categoriesByDay) {
            if (moment(dates).isSameOrAfter(today, 'day')) {
                if (categoriesByDay[dates].some(item => item === catId)) {
                    toHighlight.push(dates);
                }
            }
        }
        setAvailableDays(toHighlight);
    }

    const handleServiceCategory = (event) => {
        formik.setFieldValue("serviceCategory", event?.target?.value)
        formik.setFieldValue("date", "")
        let selectedCat = serviceCategory.find(cat => cat.id === event?.target?.value);
        setSelectedServiceCategory(selectedCat);
        setSelectedSlot("");
        formik.setFieldValue("availableSlot", "")
        setAvailableSlots([]);
        highLightDates(event?.target?.value);
    };

    function removeLateSlots(slots, date) {
        let midnight = (date) ? new Date(date) : new Date();
        // console.log("DATE", midnight) // date before processing
        midnight = new Date(midnight.setDate(midnight.getDate()+1));
        midnight.setHours(0)
        midnight.setMinutes(0)
        midnight.setSeconds(0);
        // console.log("REMOVE LATE SLOTS MIDNIGHT: ", midnight); // midnight of submitted date.
        if(Array.isArray(slots)) {
            // console.log("slot count", slots.length)
            const filteredSlots = slots.filter(slot => {
                // console.log("SLOT END", slot.end)
                let endTime = new Date(slot.end).getTime();
                let midnightTime = midnight.getTime();
                // console.log(endTime < midnightTime, slot.start)
                return (endTime < midnightTime)
            })
            // console.log("slot count after filter", filteredSlots.length)
            //setOrgSlotsData(filteredSlots);
            return filteredSlots;
        }
        else return slots;
    }

    function removeOverlappingAndPastSlots(slots) {
        const currentTime = new Date();
        const currentHour = currentTime.getHours();
        const currentMinute = currentTime.getMinutes();
        const filteredSlots = slots.filter(slot => {
            let starttime = `${(slot.start)}`;
            let endtime = `${(slot.end)}`
            let startHr = moment(starttime).hour();
            let endHr = moment(endtime).hour();
            let startMin = moment(starttime).minute();
            let endMin = moment(endtime).minute();
            
            if (
                currentHour > endHr ||
                (currentHour === endHr && currentMinute >= endMin)
            ) {
                return false;
            }
            if (
                (currentHour > startHr && currentHour < endHr) ||
                (currentHour === startHr && currentMinute >= startMin)
            ) {
                return false;
            }
            return true;
        });
        //setSlotsData(filteredSlots);
        // setSlotsData(slots);
        return filteredSlots;
    }

    function removeSlotsOutsideOfDayRange(slots, date) {
        let midnight = (date) ? new Date(date) : new Date();
        midnight = new Date(midnight.setDate(midnight.getDate()));
        midnight.setHours(0)
        midnight.setMinutes(0)
        midnight.setSeconds(0);
        // console.log("REMOVE OUTSIDE DAY RANGE MIDNIGHT: ", midnight); // start of submitted day, localtime.
        if(Array.isArray(slots)) {
            // console.log("slot count", slots.length)
            const filteredSlots = slots.filter(slot => {
                // console.log("SLOT START", slot.start)
                let startTime = new Date(slot.start).getTime();
                let midnightTime = midnight.getTime();
                // console.log(startTime > midnightTime, slot.start)
                return (startTime > midnightTime)
            })
            // console.log("slot count after filter", filteredSlots.length)
            //setOrgSlotsData(filteredSlots);
            return filteredSlots;
        }
        else return slots;
    }

    const fetchSlots = async (id, providedDate) => {
        setSlotsLoading(true);
        setAvailableSlots([])
        if(id && (formik?.values?.date || providedDate)) {
            let date = (providedDate) ? providedDate : formik?.values?.date
            let params = {
                date: moment(date).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z",
                serviceCategoryId: id,
                orgId: orgId
            };
            if(formik.values?.practitioner){
                params.actorId = practitionerId
            }else{
                params.scopeOfPractice = patientLocation 
                params.patientId = patientId
            }
            
            try {
                let fetchedSlots =await getSlots(params)
                let filteredSlots = [];
                if(fetchedSlots.status === false) { 
                    failed("No available times for this appointment type")
                }    
                if(moment(date).isSame(todayDate, "day")) {
                    filteredSlots = removeLateSlots(removeOverlappingAndPastSlots(fetchedSlots.data?.availableSlots), moment(date).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z");
                } else {
                    filteredSlots = removeLateSlots(removeSlotsOutsideOfDayRange(fetchedSlots.data?.availableSlots, moment(date).utc()), moment(date).utc());
                }
                setAvailableSlots(filteredSlots);
                setSlotsLoading(false);
            }
            catch(error) {
                setSlotsLoading(false);
                setAvailableSlots([])
            }
        }
        else {
            setAvailableSlots([]);
        }
    };

    const handleFileAttachments = (files) => {
        const selectedFilesArray = Array.from(files).slice(0, 6); // Limit to 6 files
        setSelectedFiles(prevFiles => [...prevFiles, ...selectedFilesArray]);
        formik.setFieldValue("fileAttachments", [...selectedFiles, ...selectedFilesArray]);
    };

    const renderDay = (props) => {
        const { selectedDate, day, dayComponent, ...other} = props;
        const today = moment();
        const isAvailable = availableDays.includes(day.format("YYYY-MM-DD"));
        const isSelected = day.isSame(selectedDate, "day");
        const isToday = day.isSame(today, "day");
        const isPast = day.isBefore(today, "day")

        return (
            <PickersDay {...dayComponent} 
                disabled={isPast || !isAvailable}
                style={isAvailable ? {background: "#accfeb"}: {background: "white" }} />
        );
    }

    const removeSelectedFile = (index) => {
        const updatedFiles = [...selectedFiles];
        updatedFiles.splice(index, 1);
        setSelectedFiles(updatedFiles);
        formik.setFieldValue("fileAttachments", updatedFiles);
    };

    return (
        <>
            <Modal
                backdropClassName
                backdrop={'static'}
                size='lg'
                show={bookAppointmentModalShow} onHide={handleBookAppointmentClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered className="custom-dialog">
                <Modal.Header closeButton className="border-0">
                    <Modal.Title id="contained-modal-title-vcenter">Schedule An Appointment</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
                        <Row>
                            <Col>
                                <SelectField keyField={"serviceCategory"} label={"Appointment Type"} formik={formik} options={serviceCategory} onChange={handleServiceCategory} />
                            </Col>
                            <Col>
                                <DateSelectorWithoutFormik label="Select Date" disabled = {!formik?.values?.serviceCategory} value={(formik?.values?.date?.length > 0) ? moment(formik?.values?.date) : null} formik={formik} keyField={'date'}
                                handleChange={handleDateChange} minDate={moment()} renderDay={(day, selectedDate, dayComponent) => renderDay({day, selectedDate, dayComponent})}
                                defaultValue={moment()} />
                            </Col>
                        </Row>



                        {availableSlots?.length > 0 ?
                            <>
                                <Row>
                                    <Col>Select Slot</Col>
                                </Row>
                                <Row style={{/*  justifyContent: "center", */ rowGap: "0.5rem", marginBottom: "1.5rem", marginTop: "0.5rem" }}>
                                    {availableSlots?.map((slot) => {
                                        let localTime = moment(slot?.start).format("HH:mm");
                                        return (<Col style={{ background: selectedSlot === slot?.start ? "#6c757d38" : "#ffff", width: "14.666667%" }} sm={2} className="slotStyle" key={slot?.start} onClick={() => { formik?.setFieldValue("availableSlot", slot); setSelectedSlot(slot?.start); setSlotPractitionerId(slot?.actorId) }}>{localTime}</Col>)
                                    })}
                                </Row>
                            </>
                            : null}
                        {slotsLoading ?
                            <>
                                <Row>
                                    <Col>Select Slot</Col>
                                </Row>
                                <Skeleton height={50} />
                            </>
                            : null}

                        <Row>
                            <Col>
                                <Form.Group controlId="fileAttachments">
                                    <Form.Label>File Attachments (Optional)</Form.Label>
                                    <Form.Control
                                        type="file"
                                        multiple
                                        accept=".jpg, .png, .pdf, .doc, .docx"
                                        onChange={(e) => handleFileAttachments(e.target.files)}
                                    />

                                    {selectedFiles.length > 0 && (
                                        <div className="selected-files">
                                            {selectedFiles.map((file, index) => (
                                                <div key={index} className="selected-file">
                                                    {file.name}
                                                    <span className="remove-icon" onClick={() => removeSelectedFile(index)}>
                                                        &#10006;
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="btn-wrap">
                            <Button
                                onClick={() => {
                                    handleBookAppointmentClose();
                                }}
                                variant="secondary"
                                title="Cancel"
                            >
                                Cancel
                            </Button>
                            <Button type="submit">
                                {loading ? (
                                    <CircularProgress size={24} color="inherit" />
                                ) : (
                                    "Send Request"
                                )}
                            </Button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default BookAppointmentModal;